import React from 'react';
import { Button, Modal, Popconfirm, Typography } from 'antd';
import 'fragments/follow-up-card/follow-up-card-taxes/follow-up-card-taxes.scss';
import { FollowUpCardTaxesFragmentProps } from 'fragments/follow-up-card/follow-up-card-taxes/interfaces';
import { useFollowUpCardTaxesController } from 'fragments/follow-up-card/follow-up-card-taxes/follow-up-card-taxes.controller';
import { useTranslator } from 'tools/view-hooks/translator-hook';
import { PlusOutlined, EditOutlined, DeleteOutlined } from '@ant-design/icons';
import { FollowUpCardServicesPaymentFragment } from 'fragments/follow-up-card/follow-up-card-services-payment/follow-up-card-services-payment.fragment';
import { CreateEditLiabilityFragment } from 'fragments/property-card/create-edit-liability/create-edit-liability.fragment';

export const FollowUpCardTaxesFragment: React.FC<FollowUpCardTaxesFragmentProps> = (props) => {
    const { useController = useFollowUpCardTaxesController } = props;
    const controller = useController();
    const { translate } = useTranslator();
    const { Text } = Typography;

    // Render
    return (
        <div className={'follow-up-card-taxes'}>
            <Text strong> {translate({ key: 'followUp.services-and-expenses' })} </Text>
            <Button
                icon={<PlusOutlined />}
                style={{ background: 'none', border: 'none', fontSize: 13, color: '#458be9' }}
                onClick={controller.onClickAddService}
            />
            <Button
                icon={<EditOutlined />}
                disabled={!controller.followUp.liabilities || controller.followUp.liabilities.length === 0}
                style={{ background: 'none', border: 'none', fontSize: 13, color: '#458be9' }}
                onClick={controller.onClickEditService}
            />
            <br />
            <Modal
                destroyOnClose
                title={'Agregar servicio o gasto'}
                visible={controller.isAddServiceVisible}
                onOk={controller.onClickOkayInAddServiceModal}
                onCancel={controller.onClickCancelInAddServiceModal}
            >
                <CreateEditLiabilityFragment
                    onLiabilityAdded={controller.onLiabilityAdded}
                    createForFollowUp={controller.followUp}
                    form={controller.form}
                />
            </Modal>
            <Modal
                destroyOnClose
                title={'Editar servicio o gasto'}
                visible={controller.isEditServiceVisible}
                onCancel={controller.onClickCancelInEditServiceModal}
                footer={null}
            >
                <div>
                    <p>Seleccioná el servicio o gasto que querés editar:</p>
                    {controller.followUp.liabilities?.map((liability) => (
                        <div key={liability.id} className={'liability-select-row'}>
                            <Button
                                type="link"
                                onClick={() => controller.onSelectLiabilityToEdit(liability.id)}
                                className={'liability-select-button'}
                            >
                                {liability.name || `Servicio #${liability.id}`}
                            </Button>
                            {/* Its own click target, separated from the edit button by the row's own
                                spacing, so selecting a service to edit can never accidentally delete it. */}
                            <Popconfirm
                                title={translate({ key: 'followUp.confirm-delete-liability' })}
                                onConfirm={() => controller.onClickDeleteLiability(liability.id)}
                                okText={translate({ key: 'general.remove' })}
                                cancelText={translate({ key: 'general.cancel' })}
                            >
                                <Button
                                    type="text"
                                    icon={<DeleteOutlined />}
                                    className={'liability-delete-button'}
                                    aria-label={`${translate({ key: 'general.remove' })} ${
                                        liability.name || liability.id
                                    }`}
                                />
                            </Popconfirm>
                        </div>
                    ))}
                </div>
            </Modal>
            <Modal
                destroyOnClose
                title={'Editar servicio o gasto'}
                visible={controller.isEditFormVisible}
                onOk={controller.onClickOkayInEditServiceModal}
                onCancel={controller.onClickCancelInEditServiceModal}
            >
                {controller.editFormInitialValues && (
                    <CreateEditLiabilityFragment
                        onLiabilityAdded={controller.onLiabilityEdited}
                        editValues={controller.editFormInitialValues}
                        form={controller.editForm}
                    />
                )}
            </Modal>
            <FollowUpCardServicesPaymentFragment />
        </div>
    );
};
